
export const SET_TOKEN = 'SET_TOKEN'
export const SET_IS_EMAIL_CONFIRMED = 'SET_IS_EMAIL_CONFIRMED'
export const SET_IS_LOGIN_ERROR = 'SET_IS_LOGIN_ERROR'
export const LOGOUT = 'LOGOUT'
export const SET_RECOVERY_TOKEN = 'SET_RECOVERY_TOKEN'
export const SET_IS_CONFIRM_ERROR = 'SET_IS_CONFIRM_ERROR'
